import { TimeProps } from './types'

export const formatTime = ({ days, hours, minutes, seconds }: Partial<TimeProps>): string => {
  const pad = (value: number | undefined): string =>
    value !== undefined ? (value < 10 ? `0${value}` : `${value}`) : ''

  const formattedDays = pad(days)
  const formattedHours = pad(hours)
  const formattedMinutes = pad(minutes)
  const formattedSeconds = pad(seconds)

  if (formattedDays && formattedHours && formattedMinutes && formattedSeconds) {
    return `${formattedDays}:${formattedHours}:${formattedMinutes}:${formattedSeconds}`
  }
  if (formattedHours && formattedMinutes && formattedSeconds) {
    return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`
  }
  if (formattedHours && formattedMinutes) {
    return `${formattedHours}:${formattedMinutes}`
  }
  if (formattedMinutes && formattedSeconds) {
    return `${formattedMinutes}:${formattedSeconds}`
  }
  return `${formattedSeconds}`
}
